// src/store/slices/settingsSlice.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { createGenericSlice } from './genericSliceFactory';
import { apiMethods } from '../../services/api';
import type { Settings, ApiResponse } from '@/types';

const settingsSlice = createGenericSlice<Settings>({
    name: 'settings',
    endpoint: '/settings',
});

export const {
    setCurrentItem: setCurrentSettings,
    clearError,
    setSelectedIds,
    toggleSelectId,
    clearSelectedIds,
} = settingsSlice.actions;


// ── Public endpoint ───────────────────────────────────────────────────────────

/**
 * GET /settings
 * Public — returns the currently active settings record.
 */
export const fetchActiveSettings = createAsyncThunk(
    'settings/fetchSingle',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await apiMethods.get<ApiResponse<Settings>>('/settings');
            const settings = response.data;
            dispatch(setCurrentSettings(settings));
            return settings;
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch settings');
        }
    }
);

export default settingsSlice.reducer;